import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getLayout, getRemotedbUrl, getStageName, i18nIntl, isNotEmpty, throwErrorEvent } from '../lib/ep.js';
import { useSimpleFilter } from '../lib/hooks.js';
import { getStageTypeLayout, stage_promotion_types } from '../data/bootstrap_stages';

import ActionButton, { CreateButton, SecondaryButton, SquaredButton } from '../components/builder/ActionButton.js';
import BuilderCanvas from '../components/builder/BuilderCanvas';
import BuilderSidebar from '../components/builder/BuilderSidebar';
import ButtonCollection from '../components/builder/ButtonCollection';
import Checkbox from '../components/builder/Checkbox.js';
import ColorPicker from '../components/builder/ColorPicker.js';
import ConfirmButton from '../components/builder/ConfirmButton.js';
import DynamicFields from '../components/builder/DynamicFields.js';
import FieldLabel from '../components/builder/FieldLabel.js';
import FloatingLayer from '../components/builder/FloatingLayer.js';
import Input from '../components/builder/Input';
import Model from '../components/builder/Model';
import NavigationTabs,{ NavigationTabsBuilder } from '../components/builder/NavigationTabs';
import SectionTitle from '../components/builder/SectionTitle.js';
import SectionSubtitle from '../components/builder/SectionSubtitle.js';
import SearchField from '../components/builder/SearchField.js';
import Select from '../components/builder/Select.js';
import TextArea from '../components/builder/TextArea.js';
import ToggleSectionButton from '../components/builder/ToggleSectionButton.js';

import PromotionStageMosaic from '../components/users/PromotionStageMosaic';

import Layout from '../components/front/Layout';
import BuilderMain, { BuilderMainWithoutSidebar } from '../components/builder/BuilderMain.js';
import MatrixSelector from '../components/builder/MatrixSelector.js';
import { AutoImageUploader } from '../components/builder/ImageUploader.js';

const filterFunc = (stage, value) => {
	let regex = new RegExp(value);
	return regex.test(stage.Stage.display_title);
};

const AddStageSection = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [show, setShow] = useState('pending');
	const [operations,setOperations] = useState({});
	const [stages, filterStages] = useSimpleFilter(props.stages, filterFunc);

	const search = (k, v) => {
		filterStages(v)
	};

	const sectionToStage = (section_id,stage_id) => {
		setOperations((ops) => {
			if(ops[stage_id] != undefined && ops[stage_id] == section_id) {
				return { ...ops, [stage_id]:null };
			}

			return { ...ops, [stage_id]:section_id };
		})
	};

	const confirmOperations = () => {
		for(let i in operations) {
			props.setSectionToStage(operations[i], i);
		}
		props.close();
	};

	const sections = [
		{ label:i18n("Pending"), onClick:() => setShow('pending'), selected:(show == 'pending') ? true : false },
		{ label:i18n("All"), onClick:() => setShow('all'), selected:(show == 'all') ? true : false },
	];

	const final_stages = (show == 'pending') ? stages.filter((stage) => stage.Stage.section_id == undefined) : stages;
	const stages_with_operations = final_stages.map((stage) => {
		if(operations[stage.Stage.id] == undefined) return stage;

		if(operations[stage.Stage.id] == stage.Stage.section_id) return { Stage:{ ...stage.Stage, section_id:null } };
		return { Stage:{ ...stage.Stage, section_id:operations[stage.Stage.id] } };

	});
	const thumb_image = (isNotEmpty(props.section, 'image')) ? props.section.full_image : false;
	const _title = isNotEmpty(props.section,'title',['']) ? <strong dangerouslySetInnerHTML={{ __html:props.section.title.trim()}}/> : '-';

	return (
		<FloatingLayer _class={{size:'small'}} backButton={props.close}>
			<div class="tabs_in_layer stage_list_with_tabs">
				<SectionTitle>Select and add stages to a section</SectionTitle>

				<SectionSubtitle autotranslate={false}>{i18n("Section")}: {_title}</SectionSubtitle>
				{(thumb_image !== false) && (
					<img src={thumb_image} alt="" class="img_thumb" height={20} style={{maxWidth:'none',width:'fit-content'}} />
				)}

				<NavigationTabs
					sections={sections}
					display_type='tab'
					frontend={true}
					_class={{ other:'gui_not_in_top_huge' }}
					children_class="gui_is_not_padded"
				>
					<SearchField
						_class={{first:true}}
						change={search}
					/>
				</NavigationTabs>

				{(final_stages.length > 0) && (
					<ul class="gui_overflowable list_with_tabs">
						{stages_with_operations.map((stage, st) => {
							const stage_in_section = props.stage_sections.find((s) => { return s.id == stage.Stage.section_id; });
							const section_title = (stage_in_section?.title)?.trim() ?? null;
							const is_in_this_section = (show == 'all' && stage.Stage?.section_id == props.section.id) ? true : false;
							const stage_layout = getStageTypeLayout(stage.Stage);
							const stage_title = getStageName(stage.Stage, i18n);

							return (
								<li key={`st_${st}`} class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
									<div class="item_header">
										<div class="item_title_container">
											<strong class={`${stage_layout.icon_class} item_title cutTextOnOverflow`}>
												<span>{stage_title}</span>
											</strong>

											{(stage_in_section) ? (
												<span class="additional_info" >{i18n("In section")}: {isNotEmpty(props.section,'title',['']) ? section_title : '-'}</span>
											) : (
												<span class="additional_info">-</span>
											)}
										</div>

										<ButtonCollection>
											{(!stage_in_section) && (
												<CreateButton
													onClick={() => sectionToStage(props.section.id, stage.Stage.id)}
												>Select</CreateButton>
											)}

											{(stage_in_section && !is_in_this_section) && (
												<ActionButton
													icon='knk-increase-web-traffic'
													onClick={() => sectionToStage(props.section.id, stage.Stage.id)}
												>Change</ActionButton>
											)}

											{(stage_in_section && is_in_this_section) && (
												<SquaredButton
													color='red'
													icon='knk-off'
													onClick={() => sectionToStage(props.section.id, stage.Stage.id)}
													aria-label="Delete"
												/>
											)}
										</ButtonCollection>
									</div>
								</li>
							)
						})}
					</ul>
				)}

				{(final_stages.length < 1) && (
					<ul class="list_with_tabs">
						<li class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
							<div class="item_header">
								<div class="item_title_container">
									<span class="without_icon item_title cutTextOnOverflow">{i18n("There are no results.")}</span>
									<span class="additional_info">&nbsp;</span>
								</div>
							</div>
						</li>
					</ul>
				)}

				<ButtonCollection in_floating={true}>
					<ActionButton
						onClick={confirmOperations}
					>Confirm</ActionButton>

					<SecondaryButton
						onClick={() => props.close()}
					>Close</SecondaryButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
}

const StageSection = ({ model, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [ adding_section, setAddingSection ] = useState(false);

	let stage_selector = [];
	props.stages.filter((st) => (st.Stage.section_id == model.id)).sort((a, b) => (
		(a.Stage.pos < b.Stage.pos) ? -1 : 1
	)).map((st) => {
		stage_selector.push(st.Stage);
	});

	const sortableType = props?.sortableType ?? 'date';


	return (
		<div>
			<Model model={model} change={change}>
				<Input
					name="title"
					placeholder="Section title"
					_class={{ size:80 }}
				>Title</Input>

				<TextArea
					name="description"
				>Description</TextArea>

				<AutoImageUploader
					name='image'
					auto_url={`/promotions/auto_img/${props.stages[0].Stage.promotion_id}`}
					auto_type='main'
					image={model?.full_image ?? ''}
					_size={{ fit:'auto' }}
					enable_actions={true}
					small_input={true}
					display_custom_dragging_instructions="Upload image"
				>Header image</AutoImageUploader>

				{(isNotEmpty(model, 'image')) && (
					<AutoImageUploader
						name='mobile_image'
						auto_url={`/promotions/auto_img/${props.stages[0].Stage.promotion_id}`}
						auto_type='main'
						image={model?.full_mobile_image ?? ''}
						_size={{ fit:'width', width:360 }}
						enable_actions={true}
						small_input={true}
						display_custom_dragging_instructions="Upload image"
						autotranslate={false}
					>{i18n("Header image")} ({i18n("mobile")})</AutoImageUploader>
				)}

				{/*<ColorPicker
					_class={{size:60}}
					_hide_code={true}
					name="color"
					color={model?.color ?? '#000000'}
				>Highlight color</ColorPicker>*/}

				{(adding_section) && (
					<AddStageSection
						intl={props.intl}
						stages={props.stages}
						stage_sections={props.stage_sections}
						setSectionToStage={props.setSectionToStage}
						section={model}
						close={() => setAddingSection(false)}
					/>
				)}
			</Model>

			{(stage_selector.length > 0) && (
				<div class="gui_not_in_top list_in_list">
					<div class="block_header">
						<FieldLabel _class={{other:'block_title'}}>Stages</FieldLabel>

						<ButtonCollection>
							<ActionButton
								_class={{other:'addButton gui_not_in_bottom_tiny'}}
								onClick={() => setAddingSection(true)}
							>Add stage</ActionButton>
						</ButtonCollection>
					</div>

					<ul class="gui_overflowable list_with_tabs">
						{stage_selector.map((stage, st) => {
							const prev = st - 1;
							const next = st + 1;
							const stage_title = getStageName(stage, i18n);
							const stage_layout = getStageTypeLayout(stage);

							return (
								<li key={`stage_layer_${stage.id}`} class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
									<div class="item_header">
										<div class="item_title_container">
											<strong class={`${stage_layout.icon_class} item_title cutTextOnOverflow`}>
												<span>{stage_title}</span>
											</strong>
										</div>

										<ButtonCollection>
											{(sortableType == 'manual' && stage_selector.length > 1 && prev > -1) && (
												<SquaredButton
													icon='knk-arrow-top'
													_class={{ other:'thinButton' }}
													onClick={() => props.sortStage(stage.id, stage_selector[prev].id)}
													aria-label="Move up"
												/>
											)}

											{(sortableType == 'manual' && stage_selector.length > 1 && next < stage_selector.length) && (
												<SquaredButton
													icon='knk-arrow-bottom'
													_class={{ other:'thinButton' }}
													onClick={() => props.sortStage(stage.id, stage_selector[next].id)}
													aria-label="Move down"
												/>
											)}

											{(sortableType == 'manual' && stage_selector.length > 1 && next == stage_selector.length) && (
												<SquaredButton
													icon='knk-white-space'
													_class={{ other:'thinButton gui_remove_pointer_events' }}
												/>
											)}

											<ConfirmButton
												squared={true}
												color='red'
												icon='knk-off'
												_position="left"
												onClick={() => props.setSectionToStage(model.id, stage.id)}
												aria-label="Delete"
											/>
										</ButtonCollection>
									</div>
								</li>
							)
						})}
					</ul>
				</div>
			)}

			{(stage_selector.length == 0) && (
				<div class="gui_not_in_top list_in_list">
					<div class="block_header">
						<FieldLabel _class={{other:'block_title'}}>Stages</FieldLabel>
					</div>

					<div class="empty_list_msg">
						<span>{i18n("This section has no stages yet.")}</span>

						<ButtonCollection>
							<ActionButton
								_class={{other:'addButton gui_not_in_top_small'}}
								onClick={() => setAddingSection(true)}
							>Add stages</ActionButton>
						</ButtonCollection>
					</div>
				</div>
			)}
		</div>
	)
}

const StageSections = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stages = props.stages;
	const pm = props.pm;

	const toggleSection = () => {
		props.promoChangeSave('sections_enabled', (pm?.sections_enabled) ? false : true);
	};

	const layout_props_model = getLayout(pm);

	const section_main_path = (props.section_main_path != undefined) ? props.section_main_path : 'stages';

	const is_sections_enabled = (pm?.sections_enabled) ? pm.sections_enabled : false;

	if(!is_sections_enabled) {
		return (
			<BuilderMainWithoutSidebar pm={props.promoModel} has_tabs={true}>
				<NavigationTabsBuilder active={`/${section_main_path}/sections`} sections={props.sections} />

				<section class="not_awesome">
					<div class="gui_section_header alone_section_header cleared_header">
						<SectionTitle _class={{other:'in_top'}}>Sections</SectionTitle>

						<ToggleSectionButton
							value={false}
							onClick={() => toggleSection()}
							label_on="Disable"
							label_off="Enable"
						/>
					</div>

					<SectionSubtitle>The sections allow you to present the participation stages grouped together by a common criterion. This feature helps to organize how the stages are shown to give a better user experience.</SectionSubtitle>

					<SectionSubtitle>We recommend using the sections when you have more than 15 stages.</SectionSubtitle>

					<article class="gui_not_in_top_huge">
						<div class="gui_margined_children_big_v">
							<div>
								<strong class="block_title">{i18n("Some examples of sections could be")}:</strong>
								<div>
									<ul class="bulleted_list">
										<li>{i18n("A campaign where you distribute multiple discount coupons: imagine that more than 100 stores adhere to the campaign. Each store is one stage of the promotion. You can use the sections to present the stores grouped by type of store (restaurants, fashion, beauty, etc), or by location (town1, town2, etc).")}</li>
										<li>{i18n("Campaign with multiple mini-games: Use the sections to present  the games grouped by difficulty level (easy, medium, hard), or by audience category (adults, children), or by types of games (puzzles, quizzes, instant win, etc).")}</li>
									</ul>
								</div>
							</div>

							<div>
								<strong class="block_title">{i18n("If you enable this feature, you can")}:</strong>
								<div>
									<ul class="bulleted_list">
										<li>{i18n("Create new sections.")}</li>
										<li>{i18n("Set a title, a description, and a color for each section.")}</li>
										<li>{i18n("Assign stages to each section.")}</li>
										<li>{i18n("Organize the sections and the stages within each section.")}</li>
									</ul>
								</div>
							</div>
						</div>
					</article>
				</section>
			</BuilderMainWithoutSidebar>
		)
	}

	const changeStage = (id, k, v) => {
		props.stagesStore.dispatch({ type:'CHANGE_STAGE', id, k, v });
	};

	const saveStage = (stage, cb) => {
		$.post(getRemotedbUrl(`/promotions/savestage/${stage.Stage.promotion_id}`), stage.Stage, (res) => {
			if(cb != undefined) cb();
			EP.showSuccessSave();
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});;
	};

	const setSectionToStage = (section_id, stage_id) => {
		const st = stages.find((s) => (s.Stage.id == stage_id));
		if(st.Stage?.section_id == section_id) {
			changeStage(stage_id, 'section_id', null);
		} else {
			changeStage(stage_id, 'section_id', section_id);
		}
		saveStage(stages.filter((s) => (s.Stage.id == stage_id))[0]);
	};

	const sortStage = (stage_id, switcheroo) => {
		let prev;
		const original = stages.find((s) => s.Stage.id == stage_id);
		const switching = stages.find((s) => s.Stage.id == switcheroo);
		prev = original.Stage.pos;
		original.Stage.pos = switching.Stage.pos;
		changeStage(original.Stage.id, 'pos', original.Stage.pos);
		switching.Stage.pos = prev;
		changeStage(switching.Stage.id, 'pos', prev);
		saveStage(original);
		saveStage(switching);
	};

	const sortable_stages = [
		{ k:'date', v:`${i18n("By opening date")} (${i18n("ASC")})` },
		{ k:'date_inv', v:`${i18n("By opening date")} (${i18n("DESC")})` },
		{ k:'title', v:`${i18n("By stage name")} (${i18n("ASC")})` },
		{ k:'title_inv', v:`${i18n("By stage name")} (${i18n("DESC")})` },
		{ k:'manual', v:i18n("Manual") },
	];

	const avail_locales = [];
	if(window.langs != undefined) {
		window.langs.map((loc) => {
			avail_locales.push(loc.I18nPromotion.lang);
		})
	}

	return (
		<BuilderMain pm={props.promoModel}>
			<NavigationTabsBuilder active={`/${section_main_path}/sections`} sections={props.sections} />

			<BuilderSidebar onSave={props.savePromo}>
				<article>
					<ButtonCollection>
						<ToggleSectionButton
							value={true}
							onClick={() => toggleSection()}
							label_on="Disable"
							label_off="Enable"
						/>
					</ButtonCollection>

					<Model model={pm} change={props.promoChangeSave}>
						<Select
							name="stages_mosaic_sort_mode"
							_class={{size:60}}
							values={sortable_stages}
						>Stage order</Select>

						<Checkbox
							name="sections_hide_empty"
						>Hide empty sections</Checkbox>
					</Model>

					<Model model={layout_props_model.text} change={(k, v) => props.changeLayout('text', k, v)}>
						<MatrixSelector
							name="sections_text_align"
							_default_value='center'
							use_semantics={true}
							value={pm.sections_text_align}
							allow='x_text'
							enable_justify={false}
						>Text alignment</MatrixSelector>
					</Model>
				</article>

				<article class="gui_not_in_top_huge">
					<DynamicFields
						section_title="Sections"
						section_icon="knk-groups"
						has_translation={true}
						locales={avail_locales}
						has_visibility={true}
						field_types={[{
							type:'stage_section',
							label:"Add a section",
							translate:[
								{key:'title',type:'input'},
								{key:'description',type:'textarea'}
							],
							title:(f) => { return f?.title ?? i18n("Section"); }
						}]}
						fields={pm?.stage_sections ?? []}
						onChange={(v) => props.promoChange('stage_sections', v)}
					>
						<StageSection
							stages={stages}
							stage_sections={pm.stage_sections}
							setSectionToStage={setSectionToStage}
							sortStage={sortStage}
							sortableType={pm.stages_mosaic_sort_mode}
							intl={props.intl}
						/>
					</DynamicFields>
				</article>
			</BuilderSidebar>

			<BuilderCanvas
				is_adaptable={true}
				fit_to_window="content"
				enable_actions={true}
			>
				<Layout
					promo={pm}
					menus={props.promoModel.Custom__Menus}
					is_builder={true}
					page="stage_mosaic"
				>
					<PromotionStageMosaic
						stages={stages.filter((st)=>{return st.Stage.promotion_type_id != stage_promotion_types.MEDIA_AUTOCONTENT.id})}
						promo={pm}
						is_builder={true}
					/>
				</Layout>
			</BuilderCanvas>
		</BuilderMain>
	);
}

export default injectIntl(StageSections);